export enum MessageClaraDraftSourceSeparator {
  FIELD = '; '
}
